import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.member.mgmt');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-member-mgmt',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.member.mgmt/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMemberMgmtComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public category: string = '';
    public sub: string = '';
    public routerSub: any;

    // 회원등급
    public grades: any[] = [];
    public gradeForm: any = {};
    public gradeEditing: boolean = false;

    // 회원
    public members: any[] = [];
    public memberTotal: number = 0;
    public memberPage: number = 1;
    public memberSearch: string = '';
    public memberGradeFilter: string = '';
    public memberForm: any = {};
    public memberEditing: boolean = false;

    // 포인트조정
    public pointForm: any = { member_id: '', amount: 0, reason: '' };

    // 회원정보일괄변경
    public bulkForm: any = { grade_id: '', sms_agree: '', email_agree: '', status: '' };

    // 배달지조회및변경
    public deliveryAddressText: string = '';
    public deliveryAddresses: any[] = [];

    // 회원엑셀업로드
    public uploadFile: any = null;
    public uploadResult: any = null;

    // 회원포인트변경내역
    public pointHistoryStart: string = '';
    public pointHistoryEnd: string = '';
    public pointHistoryText: string = '';
    public pointHistoryType: string = '';
    public pointHistoryData: any[] = [];

    // 외상/미수금
    public creditStart: string = '';
    public creditEnd: string = '';
    public creditText: string = '';
    public creditData: any[] = [];
    public creditSummary: any = { credit_amount: 0, paid_amount: 0, balance: 0 };
    public batchPaymentDate: string = '';
    public batchPaymentMemo: string = '';
    public receivableText: string = '';
    public receivableData: any[] = [];
    public receivableSummary: any = { total_credit: 0, total_paid: 0, total_balance: 0 };

    // 회원분석
    public analysisStart: string = '';
    public analysisEnd: string = '';
    public analysisText: string = '';
    public analysisProductText: string = '';
    public memberDailyData: any[] = [];
    public memberPeriodData: any[] = [];
    public memberProductData: any[] = [];
    public memberTendencyData: any[] = [];
    public memberShareData: any[] = [];
    public memberShareSummary: any = { total_sales: 0, member_sales: 0, member_ratio: 0 };
    public memberPointPerfData: any[] = [];
    public memberEmployeeData: any[] = [];
    public memberEmployeeFallback: string = '';

    public categories: any = {
        'info': {
            label: '회원정보',
            items: ['회원등급설정', '회원정보조회', '회원정보등록', '회원정보일괄변경', '배달지조회및변경', '회원엑셀업로드', '회원포인트조정']
        },
        'analysis': {
            label: '회원분석',
            items: ['일자별회원구매내역', '기간회원구매내역', '회원-상품 구매내역', '회원구매성향분석', '회원매출점유', '회원포인트실적', '외상발생/입금내역', '회원미수금현황', '회원유치사원별매출내역', '상품-회원 구매내역']
        }
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        const today = new Date().toISOString().slice(0, 10);
        const monthAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
        this.pointHistoryStart = monthAgo;
        this.pointHistoryEnd = today;
        this.creditStart = monthAgo;
        this.creditEnd = today;
        this.batchPaymentDate = today;
        this.analysisStart = monthAgo;
        this.analysisEnd = today;
        await this.updateRoute();
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                await this.updateRoute();
                await this.service.render();
            }
        });
        await this.service.render();
    }

    ngOnDestroy() { if (this.routerSub) this.routerSub.unsubscribe(); }

    private async updateRoute() {
        const seg = WizRoute.segment;
        this.category = seg.category || 'info';
        try { this.sub = seg.sub ? decodeURIComponent(seg.sub) : ''; } catch { this.sub = seg.sub || ''; }
        if (!seg.category) {
            this.service.href('/member/info');
            return;
        }
        if (this.sub) await this.loadSubData();
    }

    public categoryKeys(): string[] { return Object.keys(this.categories); }
    public isActiveCat(key: string): boolean { return this.category === key; }

    public async selectSub(item: string) {
        this.service.href(`/member/${this.category}/${encodeURIComponent(item)}`);
    }

    private async loadSubData() {
        if (this.sub === '회원등급설정') await this.loadGrades();
        if (this.sub === '회원정보조회' || this.sub === '회원정보등록') {
            await this.loadGrades();
            await this.loadMembers();
        }
        if (this.sub === '회원정보일괄변경') {
            await this.loadGrades();
            await this.loadMembers(200);
        }
        if (this.sub === '배달지조회및변경') await this.loadDeliveryAddresses();
        if (this.sub === '회원엑셀업로드') {
            this.uploadFile = null;
            this.uploadResult = null;
        }
        if (this.sub === '회원포인트조정') {
            await this.loadMembers();
        }
        if (this.sub === '회원포인트변경내역') await this.loadPointHistories();
        if (this.sub === '외상발생/입금내역') await this.loadCredits();
        if (this.sub === '회원미수금현황') await this.loadReceivableStatus();
        if (this.sub === '일자별회원구매내역') await this.loadMemberDailySales();
        if (this.sub === '기간회원구매내역') await this.loadMemberPeriodSales();
        if (this.sub === '회원-상품 구매내역') await this.loadMemberProductSales();
        if (this.sub === '회원구매성향분석') await this.loadMemberPurchaseTendency();
        if (this.sub === '회원매출점유') await this.loadMemberSalesShare();
        if (this.sub === '회원포인트실적') await this.loadMemberPointPerformance();
        if (this.sub === '회원유치사원별매출내역') await this.loadMemberEmployeeSales();
    }

    // ===== 회원등급 =====
    public async loadGrades() {
        let res = await wiz.call("grade_list");
        if (res.code === 200) this.grades = res.data?.data || [];
    }

    public async newGrade() {
        this.gradeForm = { name: '', discount_rate: 0, point_rate: 0, sort_order: this.grades.length + 1 };
        this.gradeEditing = true;
        await this.service.render();
    }

    public async editGrade(g: any) {
        this.gradeForm = JSON.parse(JSON.stringify(g));
        this.gradeEditing = true;
        await this.service.render();
    }

    public async saveGrade() {
        let res = await wiz.call("grade_save", this.gradeForm);
        if (res.code === 200) {
            this.gradeEditing = false;
            await this.loadGrades();
            await this.service.render();
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
        }
    }

    public async deleteGrade(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        let res = await wiz.call("grade_delete", { id });
        if (res.code !== 200) await this.service.modal.show({ title: '', message: res.data?.message || '삭제 실패', cancel: false, action: '확인', status: 'error' });
        await this.loadGrades();
        await this.service.render();
    }

    // ===== 회원 =====
    public async loadMembers(dump: number = 20) {
        let res = await wiz.call("member_list", { text: this.memberSearch, grade_id: this.memberGradeFilter, page: this.memberPage, dump });
        if (res.code === 200) {
            this.members = (res.data?.data || []).map((item: any) => ({ ...item, _selected: false }));
            this.memberTotal = res.data?.total || 0;
        }
        await this.service.render();
    }

    public async newMember() {
        this.memberForm = { member_no: '', name: '', phone: '', gender: '', birth: '', grade_id: '', point: 0, address: '' };
        this.memberEditing = true;
        await this.service.render();
    }

    public async editMember(m: any) {
        this.memberForm = JSON.parse(JSON.stringify(m));
        this.memberEditing = true;
        await this.service.render();
    }

    public async saveMember() {
        let res = await wiz.call("member_save", this.memberForm);
        if (res.code === 200) {
            this.memberEditing = false;
            await this.loadMembers();
            await this.service.render();
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '저장 실패', cancel: false, action: '확인', status: 'error' });
        }
    }

    public async deleteMember(id: string) {
        let confirm = await this.service.modal.show({ title: '', message: '삭제하시겠습니까?', action: '삭제', status: 'error' });
        if (!confirm) return;
        await wiz.call("member_delete", { id });
        await this.loadMembers();
        await this.service.render();
    }

    // ===== 포인트 조정 =====
    public async adjustPoint() {
        if (!this.pointForm.member_id) {
            await this.service.modal.show({ title: '', message: '회원을 선택하세요.', cancel: false, action: '확인', status: 'error' });
            return;
        }
        let res = await wiz.call("point_adjust", this.pointForm);
        if (res.code === 200) {
            await this.service.modal.show({ title: '', message: `포인트가 조정되었습니다. (현재: ${res.data.new_point})`, cancel: false, action: '확인', status: 'success' });
            this.pointForm = { member_id: '', amount: 0, reason: '' };
            await this.loadMembers();
        } else {
            await this.service.modal.show({ title: '', message: res.data?.message || '조정 실패', cancel: false, action: '확인', status: 'error' });
        }
        await this.service.render();
    }

    public getGradeName(gradeId: string): string {
        const g = this.grades.find(x => x.id === gradeId);
        return g ? g.name : '-';
    }

    // ===== 회원정보일괄변경 =====
    public selectedMembers(): any[] {
        return this.members.filter((item: any) => item._selected);
    }

    public allMembersSelected(): boolean {
        return this.members.length > 0 && this.members.every((item: any) => item._selected);
    }

    public async toggleAllMembers(checked: boolean) {
        this.members = this.members.map((item: any) => ({ ...item, _selected: checked }));
        await this.service.render();
    }

    public async loadBulkMembers() {
        await this.loadMembers(200);
    }

    public async applyBulkUpdate() {
        const selected = this.selectedMembers();
        if (selected.length === 0) {
            await this.service.modal.show({ title: '', message: '대상 회원을 선택하세요.', cancel: false, action: '확인', status: 'error' });
            return;
        }

        const payload: any = { ids: selected.map((item: any) => item.id).join(',') };
        if (this.bulkForm.grade_id) payload.grade_id = this.bulkForm.grade_id;
        if (this.bulkForm.sms_agree) payload.sms_agree = this.bulkForm.sms_agree;
        if (this.bulkForm.email_agree) payload.email_agree = this.bulkForm.email_agree;
        if (this.bulkForm.status) payload.status = this.bulkForm.status;

        if (Object.keys(payload).length === 1) {
            await this.service.modal.show({ title: '', message: '변경할 항목을 선택하세요.', cancel: false, action: '확인', status: 'error' });
            return;
        }

        let res = await wiz.call("member_bulk_update", payload);
        if (res.code === 200) {
            await this.service.modal.show({ title: '', message: `${res.data?.updated || 0}명의 회원 정보를 변경했습니다.`, cancel: false, action: '확인', status: 'success' });
            this.bulkForm = { grade_id: '', sms_agree: '', email_agree: '', status: '' };
            await this.loadMembers(200);
            return;
        }

        await this.service.modal.show({ title: '', message: res.data?.message || '일괄변경에 실패했습니다.', cancel: false, action: '확인', status: 'error' });
    }

    // ===== 배달지조회및변경 =====
    public async loadDeliveryAddresses() {
        let res = await wiz.call("delivery_address_list", { text: this.deliveryAddressText });
        if (res.code === 200) this.deliveryAddresses = res.data?.data || [];
        await this.service.render();
    }

    public async saveDeliveryAddress(item: any) {
        let res = await wiz.call("delivery_address_save", {
            id: item.id,
            member_id: item.member_id,
            zone_id: item.zone_id || '',
            address: item.address || '',
            phone: item.phone || '',
            is_default: item.is_default || 'N',
            is_active: item.is_active || 'Y'
        });

        if (res.code !== 200) {
            await this.service.modal.show({ title: '', message: res.data?.message || '배달지 저장에 실패했습니다.', cancel: false, action: '확인', status: 'error' });
            return;
        }

        await this.loadDeliveryAddresses();
    }

    // ===== 회원엑셀업로드 =====
    public async onUploadFileChange(event: any) {
        const files = event?.target?.files;
        this.uploadFile = files && files.length > 0 ? files[0] : null;
        this.uploadResult = null;
        await this.service.render();
    }

    public async uploadMembersExcel() {
        if (!this.uploadFile) {
            await this.service.modal.show({ title: '', message: '업로드할 파일을 선택하세요.', cancel: false, action: '확인', status: 'error' });
            return;
        }

        const formData = new FormData();
        formData.append('file', this.uploadFile);

        try {
            const response = await fetch('/wiz/api/page.member.mgmt/member_excel_upload', {
                method: 'POST',
                body: formData,
                credentials: 'same-origin'
            });
            const res = await response.json();
            if (res.code === 200) {
                this.uploadResult = res.data || null;
                await this.service.modal.show({ title: '', message: `등록 ${res.data?.inserted || 0}건, 수정 ${res.data?.updated || 0}건을 처리했습니다.`, cancel: false, action: '확인', status: 'success' });
                return;
            }
            await this.service.modal.show({ title: '', message: res.data?.message || '업로드에 실패했습니다.', cancel: false, action: '확인', status: 'error' });
        } catch (e: any) {
            await this.service.modal.show({ title: '', message: e?.message || '업로드 중 오류가 발생했습니다.', cancel: false, action: '확인', status: 'error' });
        }

        await this.service.render();
    }

    // ===== 회원포인트변경내역 =====
    public async loadPointHistories() {
        let res = await wiz.call("point_history_list", {
            start_date: this.pointHistoryStart,
            end_date: this.pointHistoryEnd,
            text: this.pointHistoryText,
            change_type: this.pointHistoryType
        });
        if (res.code === 200) this.pointHistoryData = res.data?.data || [];
        await this.service.render();
    }

    public formatPointChangeType(changeType: string): string {
        const typeMap: any = {
            earn: '적립',
            use: '사용',
            adjust: '조정'
        };
        return typeMap[changeType] || changeType || '-';
    }

    // ===== 외상 발생/입금 =====
    public async loadCredits(outstandingOnly: boolean = false) {
        let res = await wiz.call("credit_list", {
            start_date: this.creditStart,
            end_date: this.creditEnd,
            text: this.creditText,
            outstanding_only: outstandingOnly ? 'Y' : 'N'
        });
        if (res.code === 200) {
            this.creditData = (res.data?.data || []).map((item: any) => ({ ...item, _selected: false, pay_amount: item.balance || 0 }));
            this.creditSummary = res.data?.summary || { credit_amount: 0, paid_amount: 0, balance: 0 };
        }
        await this.service.render();
    }

    public selectedCredits(): any[] {
        return this.creditData.filter((item: any) => item._selected);
    }

    public allCreditsSelected(): boolean {
        return this.creditData.length > 0 && this.creditData.every((item: any) => item._selected);
    }

    public selectedCreditAmount(): number {
        return this.creditData
            .filter((item: any) => item._selected)
            .reduce((total: number, item: any) => total + Number(item.pay_amount || 0), 0);
    }

    public async toggleAllCredits(checked: boolean) {
        this.creditData = this.creditData.map((item: any) => ({ ...item, _selected: checked }));
        await this.service.render();
    }

    public async processBatchPayments() {
        const items = this.creditData
            .filter((item: any) => item._selected && Number(item.pay_amount || 0) > 0)
            .map((item: any) => ({ credit_id: item.id, amount: Number(item.pay_amount || 0) }));

        if (items.length === 0) {
            await this.service.modal.show({ title: '', message: '입금 처리할 항목을 선택하세요.', cancel: false, action: '확인', status: 'error' });
            return;
        }

        let res = await wiz.call("credit_batch_payment", {
            payment_date: this.batchPaymentDate,
            memo: this.batchPaymentMemo,
            items: JSON.stringify(items)
        });

        if (res.code === 200) {
            await this.service.modal.show({ title: '', message: `${res.data?.processed || 0}건의 입금을 처리했습니다.`, cancel: false, action: '확인', status: 'success' });
            this.batchPaymentMemo = '';
            await this.loadCredits(true);
            return;
        }

        await this.service.modal.show({ title: '', message: res.data?.message || '일괄 입금 처리에 실패했습니다.', cancel: false, action: '확인', status: 'error' });
    }

    // ===== 회원미수금현황 =====
    public async loadReceivableStatus() {
        let res = await wiz.call("receivable_status", { text: this.receivableText });
        if (res.code === 200) {
            this.receivableData = res.data?.data || [];
            this.receivableSummary = res.data?.summary || { total_credit: 0, total_paid: 0, total_balance: 0 };
        }
        await this.service.render();
    }

    // ===== 회원분석 =====
    public async loadMemberDailySales() {
        let res = await wiz.call("member_daily_sales", {
            start_date: this.analysisStart,
            end_date: this.analysisEnd,
            text: this.analysisText
        });
        if (res.code === 200) this.memberDailyData = res.data?.data || [];
        await this.service.render();
    }

    public async loadMemberPeriodSales() {
        let res = await wiz.call("member_period_sales", {
            start_date: this.analysisStart,
            end_date: this.analysisEnd,
            text: this.analysisText
        });
        if (res.code === 200) this.memberPeriodData = res.data?.data || [];
        await this.service.render();
    }

    public async loadMemberProductSales() {
        let res = await wiz.call("member_product_sales", {
            start_date: this.analysisStart,
            end_date: this.analysisEnd,
            text: this.analysisText,
            product_text: this.analysisProductText
        });
        if (res.code === 200) this.memberProductData = res.data?.data || [];
        await this.service.render();
    }

    public async loadMemberPurchaseTendency() {
        let res = await wiz.call("member_purchase_tendency", {
            start_date: this.analysisStart,
            end_date: this.analysisEnd,
            text: this.analysisText
        });
        if (res.code === 200) this.memberTendencyData = res.data?.data || [];
        await this.service.render();
    }

    public async loadMemberSalesShare() {
        let res = await wiz.call("member_sales_share", {
            start_date: this.analysisStart,
            end_date: this.analysisEnd,
            text: this.analysisText
        });
        if (res.code === 200) {
            this.memberShareData = res.data?.data || [];
            this.memberShareSummary = res.data?.summary || { total_sales: 0, member_sales: 0, member_ratio: 0 };
        }
        await this.service.render();
    }

    public async loadMemberPointPerformance() {
        let res = await wiz.call("member_point_performance", {
            start_date: this.analysisStart,
            end_date: this.analysisEnd,
            text: this.analysisText
        });
        if (res.code === 200) this.memberPointPerfData = res.data?.data || [];
        await this.service.render();
    }

    public async loadMemberEmployeeSales() {
        let res = await wiz.call("member_employee_sales", {
            start_date: this.analysisStart,
            end_date: this.analysisEnd,
            text: this.analysisText
        });
        if (res.code === 200) {
            this.memberEmployeeData = res.data?.data || [];
            this.memberEmployeeFallback = res.data?.fallback || '';
        }
        await this.service.render();
    }

    public isImplemented(): boolean {
        const implemented = [
            '회원등급설정', '회원정보조회', '회원정보등록', '회원정보일괄변경', '배달지조회및변경',
            '회원엑셀업로드', '회원포인트조정',
            '일자별회원구매내역', '기간회원구매내역', '회원-상품 구매내역', '회원구매성향분석',
            '회원매출점유', '회원포인트실적', '외상발생/입금내역', '회원미수금현황', '회원유치사원별매출내역'
        ];
        return implemented.includes(this.sub);
    }
}

export default PageMemberMgmtComponent;